export enum EncodeMode {
    URL = 'url',
    BASE64 = 'base64',
}

/**
 * 將 URLSearchParams 序列化為查詢字串，空格輸出為 %20 而非 +
 */
export const toSearchParamsString = (params: URLSearchParams): string =>
    params.toString().replace(/\+/g, '%20');

/**
 * URL/Base64 編解碼工具
 */
export const UrlEncoder = {
    encode: (
        str: string | null | undefined,
        mode: EncodeMode = EncodeMode.URL
    ): string => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }

        if (mode === EncodeMode.URL) {
            return encodeURIComponent(str);
        }
        if (mode === EncodeMode.BASE64) {
            return btoa(encodeURIComponent(str));
        }

        throw new Error(`Unknown encode mode: ${mode}`);
    },

    decode: (
        str: string | null | undefined,
        mode: EncodeMode = EncodeMode.URL
    ): string => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }

        try {
            if (mode === EncodeMode.URL) {
                return decodeURIComponent(str);
            }
            if (mode === EncodeMode.BASE64) {
                return decodeURIComponent(atob(str));
            }
        } catch (error) {
            console.warn(`Decode failed for mode=${mode}, str=${str}`, error);
            return str;
        }

        throw new Error(`Unknown decode mode: ${mode}`);
    },
} as const;
